import type { SVGProps } from 'react';

const Users = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.85446 12.8333H8.81221C9.18854 12.8333 9.48467 12.5211 9.40967 12.1523C9.20267 11.1341 8.52647 9.33331 6.33334 9.33331C4.14021 9.33331 3.46404 11.1341 3.257 12.1523C3.18201 12.5211 3.47813 12.8333 3.85446 12.8333Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 9.33331C11.8859 9.33331 12.4535 10.7652 12.6826 11.7973C12.8063 12.3546 12.3555 12.8333 11.7846 12.8333H11.1667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33333 6.83335C7.34586 6.83335 8.16667 6.01254 8.16667 5.00002C8.16667 3.9875 7.34586 3.16669 6.33333 3.16669C5.32081 3.16669 4.5 3.9875 4.5 5.00002C4.5 6.01254 5.32081 6.83335 6.33333 6.83335Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.83333 6.83335C10.8459 6.83335 11.5 6.01254 11.5 5.00002C11.5 3.9875 10.8459 3.16669 9.83333 3.16669"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Users;
